import styles from './styles.module.css'
import AdditionalInformationSelect from './vehicle-info-selects/AdditionalInformationSelect'
import MakeInformationSelect from './vehicle-info-selects/MakeInformationSelect'
import ModelInformationSelect from './vehicle-info-selects/ModelInformationSelect'
import YearInformationSelect from './vehicle-info-selects/YearInformationSelect'
import {
  CustomerVehicle,
  ICustomerVehicle,
} from '../../../../../../../../app/entities/CustomerVehicle'
import { IBrand } from '../../../../../../../../app/entities/Brand'
import { Dispatch, SetStateAction, useContext, useEffect, useRef } from 'react'
import { OrderContext } from '../../../../../../global/context/order-context/OrderContext'
import { SPECIAL_VEHICLE_MODELS, VEHICLE_NOTES } from '../../../../../../global/constants/vehicle'
export interface IVehicleInformationSelectProps {
  customerVehicle: Partial<ICustomerVehicle>
  label: string
  onChange: Function
}

export default function VehicleInformationForm({
  isVehicleBlacklisted,
  setIsVehicleBlacklisted,
}: {
  isVehicleBlacklisted: boolean
  setIsVehicleBlacklisted: Dispatch<SetStateAction<boolean>>
}) {
  const { orderData, setCustomerVehicle, setOrderNotes } = useContext(OrderContext)
  const { orderVehicles } = orderData
  const customerVehicle = orderVehicles[0]?.customerVehicle
  const machENoteAdded = useRef(false)

  // Check if Mach-E and add special note
  // DTMI specifically asked to be able to work on Mustang Mach-E models, so removing the model from the
  // blacklist check, and adding a note to the work order instead when the model is selected.
  useEffect(() => {
    const model = customerVehicle?.model || ''
    const currentNote = orderData.note || ''

    // Check if model contains "Mustang Mach-E"
    if (model.includes(SPECIAL_VEHICLE_MODELS.MACH_E) && !machENoteAdded.current) {
      if (!currentNote.includes(VEHICLE_NOTES.MACH_E_PUCK)) {
    const updatedNote = !currentNote
      ? VEHICLE_NOTES.MACH_E_PUCK
      : `${currentNote}\n\n${VEHICLE_NOTES.MACH_E_PUCK}`

        setOrderNotes(updatedNote)
        machENoteAdded.current = true
      }
    }
  }, [customerVehicle?.model, orderData.note, setOrderNotes])

  function onVehicleInformationChange(update: Record<string, any>) {
    const key = Object.keys(update)[0]

    if (key === 'brand') {
      setCustomerVehicle({
        ...update,
        year: '',
        model: '',
        variant: '',
      } as CustomerVehicle)
    } else if (key === 'year') {
      setCustomerVehicle({
        ...update,
        model: '',
        variant: '',
      } as CustomerVehicle)
    } else if (key === 'model') {
      setCustomerVehicle({
        ...update,
        variant: '',
      } as CustomerVehicle)
    } else {
      setCustomerVehicle({
        ...update,
      } as CustomerVehicle)
    }
  }

  return (
    <div className={styles.contactFormContainer}>
      <div className={`${styles.contactTitle} font--bold`}>
        Vehicle Information
      </div>
      <MakeInformationSelect
        label='Make'
        customerVehicle={customerVehicle || {}}
        onChange={(brand: Partial<IBrand>) =>
          onVehicleInformationChange({ brand })
        }
      />
      {customerVehicle?.brand?.objectId && (
        <YearInformationSelect
          label='Year'
          customerVehicle={customerVehicle}
          onChange={(year: string) => onVehicleInformationChange({ year })}
        />
      )}
      {customerVehicle?.year && (
        <ModelInformationSelect
          label='Model'
          customerVehicle={customerVehicle}
          onChange={(model: string) => onVehicleInformationChange({ model })}
        />
      )}
      {customerVehicle?.model && (
        <AdditionalInformationSelect
          // this key causes this component to rerender on each customerVehicle
          // change to prevent the customer from editing vehicle to schedule a blacklisted vehicle
          key={`${customerVehicle?.brand?.objectId}-${customerVehicle?.year}-${customerVehicle?.model}`}
          label='Additional Information'
          customerVehicle={customerVehicle}
          onChange={(variant: string) =>
            onVehicleInformationChange({ variant })
          }
          setIsVehicleBlacklisted={setIsVehicleBlacklisted}
        />
      )}
      {isVehicleBlacklisted && (
        <div style={{ color: 'red' }}>
          This vehicle cannot be serviced by Mobile Installation
        </div>
      )}
    </div>
  )
}
